import { HttpApiService } from "@/shared/services/httpApi.service";

/**
 * The organization's own standing receiving accounts — coloca-nest `InternalDepositAccountsController` (`GET
 * /internal/payments/deposit-accounts`, `payments:read`).
 *
 * México SPEI and Argentina CBU/CVU are push-detected: nothing is created, the payer transfers to a fixed
 * account and the provider webhook credits it. Until this endpoint existed those numbers lived only behind
 * the staff-only `bitso/{clabes,cvus}` config surface, so the panel could only tell the client to ask their
 * account executive.
 *
 * Not to be confused with `payments-config/services/depositAccounts.service.ts`, which is the staff
 * registration surface for the same mappings.
 */

export type DepositAccountType = "CLABE" | "CVU";

export interface DepositAccount {
  rail: string;
  /** ISO-3166 alpha-3. */
  country: string;
  currency: string;
  account_type: DepositAccountType;
  account_number: string;
}

export interface DepositAccountsResponse {
  accounts: DepositAccount[];
}

const DEPOSIT_ACCOUNTS_URL = "/internal/payments/deposit-accounts";

export const OrgDepositAccountsService = {
  async list(organizationId?: string): Promise<DepositAccountsResponse> {
    const query = organizationId ? `?organization_id=${encodeURIComponent(organizationId)}` : "";
    const { data } = await HttpApiService.get<DepositAccountsResponse>(`${DEPOSIT_ACCOUNTS_URL}${query}`);
    return data;
  },
};
